import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { AppSwitcher } from '../../shared/components';
import './CollegeAlgebraNavBar.css';

// Deliberately separate from shared/components/NavBar.js -- this is the
// title bar for a second, distinct page tree (see CollegeAlgebraApp.js), not
// a variant of the SAT Prep header. Same account/auth, different app.
export default function CollegeAlgebraNavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  function handleLogout() {
    logout();
    navigate('/login');
  }

  return (
    <nav className="ca-navbar">
      <div className="ca-navbar-left">
        <AppSwitcher current="college-algebra" />
        <div className="ca-navbar-brand">
          <Link to="/college-algebra">
            <span className="ca-navbar-brand-icon" aria-hidden="true">&fnof;(x)</span>
            College Algebra
          </Link>
        </div>
      </div>

      <button
        className="ca-navbar-toggle"
        aria-label="Toggle navigation"
        onClick={() => setMenuOpen((open) => !open)}
      >
        &#9776;
      </button>

      <div className={`ca-navbar-links ${menuOpen ? 'ca-navbar-links--open' : ''}`}>
        {user && (
          <>
            <Link to="/college-algebra" onClick={() => setMenuOpen(false)}>Units</Link>
            <button className="ca-navbar-logout" onClick={handleLogout}>Log out</button>
          </>
        )}
      </div>
    </nav>
  );
}
